import keyBy from 'lodash/keyBy';
import Vue from 'vue';
import { saveWrap } from './helpers';
import * as tagApi from '@authoringPlatform/../api/tags';

const getDefaultState = () => ({
  tags: {},
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    createTag: saveWrap(async ({ commit }, payload) => {
      const newTag = await tagApi.createTag(payload);
      commit('ADD_TAG', {
        ...newTag,
        questions: new Set(),
      });
      return newTag;
    }),

    updateTag: saveWrap(async ({ commit }, { tagKey, payload }) => {
      await tagApi.updateTag({ tagKey, payload });
      commit('UPDATE_TAG', { tagKey, payload });
    }),

    deleteTag: saveWrap(async ({ state, commit }, tagKey) => {
      const tagToBeDeleted = state.tags[tagKey];
      await tagApi.deleteTag({ tagKey });

      commit('DELETE_TAG', { tagKey });
      // Deleting relationships
      tagToBeDeleted.questions.forEach((questionKey) => {
        commit(
          'editMode/questions/DELETE_TAG_FROM_QUESTION',
          { tagKey, questionKey },
          { root: true }
        );
      });
    }),

    addTagToQuestion: saveWrap(async ({ commit }, { tagKey, questionKey }) => {
      await tagApi.addTagToQuestion({ tagKey, questionKey });
      commit('editMode/questions/ADD_TAG_TO_QUESTION', { tagKey, questionKey }, { root: true });
      commit('ADD_QUESTION_TO_TAG', { tagKey, questionKey });
    }),

    removeTagFromQuestion: saveWrap(async ({ commit }, { tagKey, questionKey }) => {
      await tagApi.removeTagFromQuestion({ tagKey, questionKey });
      commit(
        'editMode/questions/DELETE_TAG_FROM_QUESTION',
        { tagKey, questionKey },
        { root: true }
      );
      commit('REMOVE_QUESTION_FROM_TAG', { tagKey, questionKey });
    }),
  },

  mutations: {
    INITIALIZE_TAGS: (state, { tags }) => {
      const parsedTags = tags.map((tag) => {
        const questionKeys = tag.questions.map((q) => q.questionKey);
        return {
          ...tag,
          questions: new Set(questionKeys),
        };
      });
      state.tags = keyBy(parsedTags, 'tagKey');
    },
    ADD_TAG: (state, newTag) => {
      Vue.set(state.tags, newTag.tagKey, newTag);
    },
    UPDATE_TAG: (state, { tagKey, payload }) => {
      const targetTag = state.tags[tagKey];
      Vue.set(state.tags, tagKey, {
        ...targetTag,
        ...payload,
      });
    },
    DELETE_TAG: (state, { tagKey }) => {
      Vue.delete(state.tags, tagKey);
    },
    ADD_QUESTION_TO_TAG: (state, { tagKey, questionKey }) => {
      const targetTag = state.tags[tagKey];
      const newSet = new Set(targetTag.questions);
      newSet.add(questionKey);
      Vue.set(targetTag, 'questions', newSet);
    },
    REMOVE_QUESTION_FROM_TAG: (state, { tagKey, questionKey }) => {
      const targetTag = state.tags[tagKey];
      const newSet = new Set(targetTag.questions);
      newSet.delete(questionKey);
      Vue.set(targetTag, 'questions', newSet);
    },
  },
};
